(function () {
  'use strict';

  const STORAGE_KEY = 'motoavenueCompare';
  const COLLAPSED_KEY = 'motoavenueCompareTrayCollapsed';
  const MAX_ITEMS = 4;
  const COMPARE_URL = '/pages/wishlist?view=compare';
  const LIMIT_MESSAGE = 'You can compare a maximum of 4 products.';
  const COMPARE_FIELDS = [
    { key: 'price', label: 'Price' },
    { key: 'comparePrice', label: 'Compare at' },
    { key: 'vendor', label: 'Brand' },
    { key: 'type', label: 'Category' },
    { key: 'availability', label: 'Availability' },
    { key: 'sku', label: 'SKU' },
    { key: 'weight', label: 'Weight' },
    { key: 'dimensions', label: 'Dimensions' },
    { key: 'origin', label: 'Country of Origin' },
    { key: 'hsCode', label: 'HS Code' }
  ];

  const escapeHtml = function (value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  };

  const slugify = function (value) {
    return String(value || '').trim().toLowerCase().replace(/\s+/g, '-');
  };

  const getCompareProducts = function () {
    let parsed = [];

    try {
      parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (error) {
      parsed = [];
    }

    const seen = new Set();
    return (Array.isArray(parsed) ? parsed : []).map(normalizeProduct).filter(function (item) {
      if (!item.id || seen.has(item.id)) return false;
      seen.add(item.id);
      return true;
    }).slice(0, MAX_ITEMS);
  };

  const saveCompareProducts = function (items) {
    const seen = new Set();
    const normalized = (Array.isArray(items) ? items : []).map(normalizeProduct).filter(function (item) {
      if (!item.id || seen.has(item.id) || seen.size >= MAX_ITEMS) return false;
      seen.add(item.id);
      return true;
    });

    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized));
    } catch (error) {
      return;
    }

    document.dispatchEvent(new CustomEvent('moto:compare-updated', {
      detail: { items: normalized }
    }));
  };

  function normalizeProduct(product) {
    const source = product || {};
    const id = source.id || source.handle || source.productId || source.variantId || slugify(source.title || source.url);

    return {
      id: String(id || ''),
      productId: source.productId || '',
      variantId: source.variantId || '',
      handle: source.handle || '',
      title: source.title || 'Product',
      url: source.url || (source.handle ? `/products/${source.handle}` : window.location.pathname),
      image: source.image || '',
      vendor: source.vendor || 'Moto Avenue',
      price: source.price || '',
      comparePrice: source.comparePrice || '',
      type: source.type || '',
      availability: source.availability || '',
      sku: source.sku || '',
      weight: source.weight || '',
      dimensions: source.dimensions || '',
      origin: source.origin || '',
      hsCode: source.hsCode || ''
    };
  }

  function productFromButton(button) {
    const card = button.closest('.product-card-wrapper, .card-wrapper, .product-card, .pdp-info-card, [data-product-details]');
    const details = button.closest('.pdp-info-card') || document.querySelector('.pdp-info-card');
    const titleNode = card?.querySelector?.('.card__heading a, .title a, .title .link, .pdp-title') || details?.querySelector?.('.pdp-title');
    const imageNode = card?.querySelector?.('.card__media img, .product-card__thumb img') || document.querySelector('.pdp-gallery-main img');
    const priceNode = card?.querySelector?.('.price-item--regular, .product-card__price .text-heading, .pdp-price-current') || details?.querySelector?.('.pdp-price-current');
    const comparePriceNode = card?.querySelector?.('.price-item--sale, .product-card__price .text-decoration-line-through, .pdp-price-original, s, del') || details?.querySelector?.('.pdp-price-original');
    const variantInput = details?.querySelector?.('input[name="id"]') || card?.querySelector?.('input[name="id"]');
    const handle = button.getAttribute('data-product-handle') || card?.getAttribute?.('data-product-handle') || '';

    return normalizeProduct({
      id: handle || button.getAttribute('data-shopify-product-id') || card?.getAttribute?.('data-shopify-product-id') || '',
      productId: button.getAttribute('data-shopify-product-id') || card?.getAttribute?.('data-shopify-product-id') || '',
      variantId: button.getAttribute('data-variant-id') || variantInput?.value || card?.getAttribute?.('data-variant-id') || '',
      handle: handle,
      title: button.getAttribute('data-compare-title') || card?.getAttribute?.('data-product-title') || titleNode?.textContent?.trim() || '',
      url: button.getAttribute('data-product-url') || titleNode?.getAttribute?.('href') || (handle ? `/products/${handle}` : window.location.pathname),
      image: button.getAttribute('data-compare-image') || card?.getAttribute?.('data-product-image') || imageNode?.currentSrc || imageNode?.getAttribute?.('src') || '',
      vendor: button.getAttribute('data-compare-vendor') || card?.getAttribute?.('data-product-vendor') || '',
      price: button.getAttribute('data-compare-price') || priceNode?.textContent?.replace(/\s+/g, ' ').trim() || '',
      comparePrice: button.getAttribute('data-compare-compare-price') || comparePriceNode?.textContent?.replace(/\s+/g, ' ').trim() || '',
      type: button.getAttribute('data-compare-type') || '',
      availability: button.getAttribute('data-compare-availability') || '',
      sku: button.getAttribute('data-compare-sku') || '',
      weight: button.getAttribute('data-compare-weight') || '',
      dimensions: button.getAttribute('data-compare-dimensions') || '',
      origin: button.getAttribute('data-compare-origin') || '',
      hsCode: button.getAttribute('data-compare-hs-code') || ''
    });
  }

  const addToCompare = function (product) {
    const item = normalizeProduct(product);
    const items = getCompareProducts();

    if (!item.id) return false;
    if (items.some(function (stored) { return stored.id === item.id; })) return true;

    if (items.length >= MAX_ITEMS) {
      showMessage(LIMIT_MESSAGE);
      return false;
    }

    items.unshift(item);
    saveCompareProducts(items);
    refreshCompareUi();
    return true;
  };

  const removeFromCompare = function (productId) {
    saveCompareProducts(getCompareProducts().filter(function (item) {
      return item.id !== productId;
    }));
    refreshCompareUi();
  };

  const toggleCompare = function (product) {
    const item = normalizeProduct(product);
    const items = getCompareProducts();
    const existingIndex = items.findIndex(function (stored) {
      return stored.id === item.id;
    });

    if (existingIndex >= 0) {
      items.splice(existingIndex, 1);
      saveCompareProducts(items);
      refreshCompareUi();
      return false;
    }

    return addToCompare(item);
  };

  function isMobile() {
    return window.matchMedia('(max-width: 991px)').matches;
  }

  function isCollapsed() {
    if (isMobile()) return true;
    try {
      return window.localStorage.getItem(COLLAPSED_KEY) === 'true';
    } catch (error) {
      return false;
    }
  }

  function setCollapsed(collapsed) {
    if (isMobile()) {
      return;
    }
    try {
      window.localStorage.setItem(COLLAPSED_KEY, collapsed ? 'true' : 'false');
    } catch (error) {
      /* ignore storage failures */
    }

    updateCompareBar();
  }

  function ensureDrawerElements() {
    let overlay = document.querySelector('.ma-compare-drawer-overlay');
    let drawer = document.querySelector('.ma-compare-drawer');

    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'ma-compare-drawer-overlay';
      overlay.setAttribute('data-compare-drawer-overlay', '');
      document.body.appendChild(overlay);
    }

    if (!drawer) {
      drawer = document.createElement('div');
      drawer.className = 'ma-compare-drawer';
      drawer.setAttribute('data-compare-drawer', '');
      document.body.appendChild(drawer);
    }

    return { overlay: overlay, drawer: drawer };
  }

  function openCompareDrawer() {
    const els = ensureDrawerElements();
    const items = getCompareProducts();

    els.drawer.innerHTML = '' +
      '<div class="ma-compare-drawer__header">' +
      '<h3>Compare Products (' + items.length + ')</h3>' +
      '<button type="button" class="ma-compare-drawer__close" data-compare-drawer-close>&times;</button>' +
      '</div>' +
      '<div class="ma-compare-drawer__body">' +
      items.map(function (item) {
        return '' +
          '<article class="ma-compare-drawer__item">' +
          '<div class="ma-compare-drawer__item-thumb">' +
          (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '">' : '<span>' + escapeHtml(item.title.charAt(0) || 'P') + '</span>') +
          '</div>' +
          '<div class="ma-compare-drawer__item-info">' +
          '<a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a>' +
          '<strong>' + escapeHtml(item.price || 'View product') + '</strong>' +
          '</div>' +
          '<button type="button" class="ma-compare-drawer__item-remove" data-compare-remove="' + escapeHtml(item.id) + '" aria-label="Remove ' + escapeHtml(item.title) + '">&times;</button>' +
          '</article>';
      }).join('') +
      '</div>' +
      '<div class="ma-compare-drawer__footer">' +
      '<button type="button" class="ma-wishlist-btn ma-wishlist-btn--ghost" data-compare-clear>Clear All</button>' +
      '<button type="button" class="ma-wishlist-btn ma-wishlist-btn--primary" data-compare-go>Compare</button>' +
      '</div>';

    els.overlay.classList.add('is-open');
    els.drawer.classList.add('is-open');
    document.body.classList.add('compare-drawer-open');

    els.overlay.onclick = closeCompareDrawer;
  }

  function closeCompareDrawer() {
    const overlay = document.querySelector('.ma-compare-drawer-overlay');
    const drawer = document.querySelector('.ma-compare-drawer');
    if (overlay) overlay.classList.remove('is-open');
    if (drawer) drawer.classList.remove('is-open');
    document.body.classList.remove('compare-drawer-open');
  }

  function ensureCompareBar() {
    let bar = document.querySelector('[data-compare-tray]');

    if (!bar) {
      bar = document.createElement('div');
      bar.setAttribute('data-compare-tray', '');
      bar.className = 'ma-compare-tray d-none';
      document.body.appendChild(bar);
    }

    if (!bar.querySelector('[data-compare-tray-items]')) {
      bar.innerHTML = '' +
        '<button type="button" class="ma-compare-tray__restore" data-compare-restore aria-label="Open compare bar">' +
        '<span data-compare-restore-count>0</span>' +
        '<i class="ph ph-scales"></i>' +
        '</button>' +
        '<div class="ma-compare-tray__inner">' +
        '<div class="ma-compare-tray__copy">' +
        '<p class="ma-compare-tray__eyebrow">Compare products</p>' +
        '<strong data-compare-tray-count>0/4 products selected</strong>' +
        '</div>' +
        '<div class="ma-compare-tray__items" data-compare-tray-items></div>' +
        '<div class="ma-compare-tray__actions">' +
        '<button type="button" class="ma-wishlist-btn ma-wishlist-btn--primary" data-compare-go>Compare</button>' +
        '<button type="button" class="ma-wishlist-btn ma-wishlist-btn--ghost" data-compare-clear>Clear All</button>' +
        '<button type="button" class="ma-compare-tray__icon-btn" data-compare-minimize aria-label="Minimize compare bar"><i class="ph ph-minus"></i></button>' +
        '</div>' +
        '</div>';
    }

    return bar;
  }

  const updateCompareBar = function () {
    const bar = ensureCompareBar();
    const items = getCompareProducts();
    const count = bar.querySelector('[data-compare-tray-count]');
    const restoreCount = bar.querySelector('[data-compare-restore-count]');
    const list = bar.querySelector('[data-compare-tray-items]');
    const mobile = isMobile();

    bar.classList.toggle('d-none', items.length === 0);
    bar.classList.toggle('is-minimized', items.length > 0 && isCollapsed());
    bar.classList.toggle('is-mobile-compact', items.length > 0 && mobile);

    if (count) {
      count.textContent = `${items.length}/${MAX_ITEMS} ${items.length === 1 ? 'product' : 'products'} selected`;
    }

    if (restoreCount) {
      restoreCount.textContent = items.length;
    }

    if (list && !mobile) {
      list.innerHTML = items.map(function (item) {
        return '' +
          '<article class="ma-compare-tray__item">' +
          '<a href="' + escapeHtml(item.url) + '" class="ma-compare-tray__thumb" aria-label="' + escapeHtml(item.title) + '">' +
          (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '">' : '<span>' + escapeHtml(item.title.charAt(0) || 'P') + '</span>') +
          '</a>' +
          '<div class="ma-compare-tray__meta">' +
          '<a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a>' +
          '<strong>' + escapeHtml(item.price || 'View product') + '</strong>' +
          '</div>' +
          '<button type="button" class="ma-compare-tray__remove" data-compare-remove="' + escapeHtml(item.id) + '" aria-label="Remove ' + escapeHtml(item.title) + ' from compare">&times;</button>' +
          '</article>';
      }).join('');
    }
  };

  function syncButtons() {
    const ids = new Set(getCompareProducts().map(function (item) { return item.id; }));

    document.querySelectorAll('[data-compare-button]').forEach(function (button) {
      const item = productFromButton(button);
      const active = item.id ? ids.has(item.id) : false;
      const label = active ? 'Remove from Compare' : 'Add to Compare';

      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', label);
      button.setAttribute('title', label);
    });
  }

  function isCompareView() {
    const pathname = window.location.pathname.replace(/\/+$/, '') || '/';
    const params = new URLSearchParams(window.location.search);
    return pathname === '/pages/compare' || (pathname === '/pages/wishlist' && params.get('view') === 'compare');
  }

  function syncComparePageTitle() {
    if (!isCompareView()) {
      return;
    }

    document.title = 'Compare Products';
    document.body.classList.add('compare-page');
    document.querySelectorAll('.shared-page-hero__title, .shared-page-hero__current, .main-page-title').forEach(function (node) {
      node.textContent = 'Compare Products';
    });
  }

  function valuesAreSame(items, key) {
    const values = items.map(function (item) {
      return String(item[key] || '').trim().toLowerCase();
    });

    return values.every(function (value) {
      return value === values[0];
    });
  }

  function ensureComparePageShell() {
    let page = document.querySelector('[data-compare-page]');

    if (page) {
      return page;
    }

    if (!isCompareView()) {
      return null;
    }

    const host = document.querySelector('.main-page-title + .rte') || document.querySelector('.page-width .rte') || document.querySelector('.rte');

    if (!host) {
      return null;
    }

    syncComparePageTitle();
    host.innerHTML = '' +
      '<section class="ma-compare-page" data-compare-page>' +
      '<div class="ma-compare-page__header">' +
      '<div>' +
      '<p class="ma-wishlist-eyebrow">Compare products</p>' +
      '<h2>Find the right fit side by side</h2>' +
      '<p class="ma-compare-page__lead">Compare pricing, availability, and core specs without jumping between tabs.</p>' +
      '</div>' +
      '<div class="ma-compare-page__controls">' +
      '<label class="ma-compare-toggle">' +
      '<input type="checkbox" data-compare-show-diff>' +
      '<span>Show differences only</span>' +
      '</label>' +
      '<button type="button" class="ma-wishlist-btn ma-wishlist-btn--ghost d-none" data-compare-clear>Clear Compare</button>' +
      '</div>' +
      '</div>' +
      '<div class="ma-compare-empty d-none" data-compare-empty>' +
      '<div class="wishlist-page__empty-icon mx-auto mb-16"><i class="ph ph-scales"></i></div>' +
      '<h5 class="mb-8">No products in compare yet</h5>' +
      '<p class="text-gray-500 mb-20">Open a product page, tap the compare icon, and we will line them up here for you.</p>' +
      '<a href="/collections/all" class="ma-wishlist-btn ma-wishlist-btn--primary">Browse Products</a>' +
      '</div>' +
      '<div class="ma-compare-table-wrap" data-compare-table-wrap></div>' +
      '<div class="ma-compare-mobile-cards" data-compare-mobile-cards></div>' +
      '</section>';

    return host.querySelector('[data-compare-page]');
  }

  function renderComparePage() {
    const page = ensureComparePageShell();

    if (!page) {
      return;
    }

    const items = getCompareProducts();
    const emptyState = page.querySelector('[data-compare-empty]');
    const tableWrap = page.querySelector('[data-compare-table-wrap]');
    const mobileCards = page.querySelector('[data-compare-mobile-cards]');
    const clearButtons = page.querySelectorAll('[data-compare-clear]');
    const diffToggle = page.querySelector('[data-compare-show-diff]');
    const showDiffOnly = Boolean(diffToggle && diffToggle.checked);

    clearButtons.forEach(function (button) {
      button.classList.toggle('d-none', items.length === 0);
    });

    if (!tableWrap || !emptyState) {
      return;
    }

    if (!items.length) {
      tableWrap.innerHTML = '';
      if (mobileCards) mobileCards.innerHTML = '';
      emptyState.classList.remove('d-none');
      return;
    }

    emptyState.classList.add('d-none');

    const visibleFields = COMPARE_FIELDS.filter(function (field) {
      return !showDiffOnly || !valuesAreSame(items, field.key);
    });

    tableWrap.innerHTML = '' +
      '<table class="ma-compare-table">' +
      '<thead>' +
      '<tr>' +
      '<th class="ma-compare-table__label">Product details</th>' +
      items.map(function (item) {
        return '' +
          '<th>' +
          '<article class="ma-compare-product">' +
          '<button type="button" class="ma-compare-product__remove" data-compare-remove="' + escapeHtml(item.id) + '" aria-label="Remove ' + escapeHtml(item.title) + '">&times;</button>' +
          '<a href="' + escapeHtml(item.url) + '" class="ma-compare-product__media">' +
          (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '">' : '<span>' + escapeHtml(item.title.charAt(0) || 'P') + '</span>') +
          '</a>' +
          '<h3 class="ma-compare-product__title">' +
          '<a href="' + escapeHtml(item.url) + '">' +
          escapeHtml(item.title) +
          '</a>' +
          '</h3>' +
          '<div class="ma-compare-product__actions">' +
          '<a href="' + escapeHtml(item.url) + '" class="ma-wishlist-btn ma-wishlist-btn--primary" style="width:180px;">' +
          'View' +
          '</a>' +
          '</div>' +
          '</article>' +
          '</th>';
      }).join('') +
      '</tr>' +
      '</thead>' +
      '<tbody>' +
      visibleFields.map(function (field) {
        const sameRow = valuesAreSame(items, field.key);

        return '' +
          '<tr' + (sameRow ? '' : ' class="is-different"') + '>' +
          '<th scope="row" class="ma-compare-table__label">' + escapeHtml(field.label) + '</th>' +
          items.map(function (item) {
            const value = item[field.key];
            return '<td>' + (value ? escapeHtml(value) : '<span class="ma-compare-table__empty">—</span>') + '</td>';
          }).join('') +
          '</tr>';
      }).join('') +
      '</tbody>' +
      '</table>';

    if (mobileCards) {
      mobileCards.innerHTML = items.map(function (item) {
        var fieldsHtml = visibleFields.map(function (field) {
          var value = item[field.key];
          return '' +
            '<div class="ma-compare-mobile-card__row">' +
            '<span class="ma-compare-mobile-card__label">' + escapeHtml(field.label) + '</span>' +
            '<span class="ma-compare-mobile-card__value">' + (value ? escapeHtml(value) : '<span class="ma-compare-table__empty">—</span>') + '</span>' +
            '</div>';
        }).join('');

        return '' +
          '<article class="ma-compare-mobile-card">' +
          '<div class="ma-compare-mobile-card__header">' +
          '<button type="button" class="ma-compare-product__remove" data-compare-remove="' + escapeHtml(item.id) + '" aria-label="Remove ' + escapeHtml(item.title) + '">&times;</button>' +
          '<a href="' + escapeHtml(item.url) + '" class="ma-compare-mobile-card__media">' +
          (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '">' : '<span>' + escapeHtml(item.title.charAt(0) || 'P') + '</span>') +
          '</a>' +
          '<div class="ma-compare-mobile-card__info">' +
          '<h3><a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a></h3>' +
          (item.price ? '<strong>' + escapeHtml(item.price) + '</strong>' : '') +
          '</div>' +
          '</div>' +
          '<div class="ma-compare-mobile-card__fields">' +
          fieldsHtml +
          '</div>' +
          '<div class="ma-compare-mobile-card__actions">' +
          '<a href="' + escapeHtml(item.url) + '" class="ma-wishlist-btn ma-wishlist-btn--primary">View Product</a>' +
          '</div>' +
          '</article>';
      }).join('');
    }
  }

  function refreshCompareUi() {
    syncButtons();
    updateCompareBar();
    renderComparePage();
  }

  function showMessage(message) {
    let toast = document.querySelector('[data-compare-toast]');

    if (!toast) {
      toast = document.createElement('div');
      toast.setAttribute('data-compare-toast', '');
      toast.className = 'ma-compare-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }

    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(window.__MOTO_COMPARE_STANDALONE_TOAST);
    window.__MOTO_COMPARE_STANDALONE_TOAST = window.setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2600);
  }

  function handleClick(event) {
    const compareButton = event.target.closest('[data-compare-button]');
    const removeButton = event.target.closest('[data-compare-remove]');
    const clearButton = event.target.closest('[data-compare-clear]');
    const goButton = event.target.closest('[data-compare-go]');
    const minimizeButton = event.target.closest('[data-compare-minimize]');
    const restoreButton = event.target.closest('[data-compare-restore]');
    const drawerClose = event.target.closest('[data-compare-drawer-close]');

    if (!compareButton && !removeButton && !clearButton && !goButton && !minimizeButton && !restoreButton && !drawerClose) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (compareButton) {
      toggleCompare(productFromButton(compareButton));
      return;
    }

    if (removeButton) {
      removeFromCompare(removeButton.getAttribute('data-compare-remove'));
      if (isMobile()) openCompareDrawer();
      return;
    }

    if (clearButton) {
      saveCompareProducts([]);
      closeCompareDrawer();
      refreshCompareUi();
      return;
    }

    if (goButton) {
      window.location.href = COMPARE_URL;
      return;
    }

    if (minimizeButton) {
      setCollapsed(true);
      return;
    }

    if (restoreButton) {
      if (isMobile()) {
        openCompareDrawer();
      } else {
        setCollapsed(false);
      }
    }

    if (drawerClose) {
      closeCompareDrawer();
    }
  }

  function initCompareProducts() {
    document.removeEventListener('click', handleClick, true);
    document.addEventListener('click', handleClick, true);
    document.addEventListener('moto:compare-updated', refreshCompareUi);
    document.addEventListener('change', function (event) {
      if (!event.target.matches('[data-compare-show-diff]')) {
        return;
      }

      renderComparePage();
    });
    refreshCompareUi();

    if (typeof MutationObserver !== 'undefined' && !window.__MOTO_COMPARE_STANDALONE_OBSERVER) {
      window.__MOTO_COMPARE_STANDALONE_OBSERVER = new MutationObserver(syncButtons);
      window.__MOTO_COMPARE_STANDALONE_OBSERVER.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  window.MotoCompare = {
    getCompareProducts: getCompareProducts,
    addToCompare: addToCompare,
    removeFromCompare: removeFromCompare,
    updateCompareBar: updateCompareBar,
    toggleCompare: toggleCompare,
    saveCompareProducts: saveCompareProducts
  };
  window.getCompareProducts = getCompareProducts;
  window.addToCompare = addToCompare;
  window.removeFromCompare = removeFromCompare;
  window.updateCompareBar = updateCompareBar;
  window.toggleCompare = toggleCompare;
  window.saveCompareProducts = saveCompareProducts;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCompareProducts);
  } else {
    initCompareProducts();
  }
})();
